import simulatorTrainingRoutes from 'modules/simulatorTrainings/common/routing/routes'

const routes = {
  root: `${simulatorTrainingRoutes.instructorSL}/exercise/sheet`,
}

export default routes
